import { render, staticRenderFns } from "./RecordSale.vue?vue&type=template&id=03ffaa08&scoped=true&"
import script from "./RecordSale.vue?vue&type=script&lang=js&"
export * from "./RecordSale.vue?vue&type=script&lang=js&"
import style0 from "./RecordSale.vue?vue&type=style&index=0&id=03ffaa08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ffaa08",
  null
  
)

export default component.exports